import {createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';
import { acceptCoursePolicy, AcceptCoursePolicyParams, getCoursePolicy } from '../api/platform';

export interface AcceptCoursePolicyEventsObjectState {
  coursePolicyData: {
    isAccept: boolean;
    coursePolicyUrl: string;
  };
  isLoading: boolean;
  error: string;
}

const initialState: AcceptCoursePolicyEventsObjectState = {
  coursePolicyData: {
    isAccept: false,
    coursePolicyUrl: ''
  },
  isLoading: false,
  error: ''
};

export const getCoursePolicyEvents:any = createAsyncThunk(
  'getCoursepolicyEventsPlatform',
  async (training_result_id: number) => {
    const response = await getCoursePolicy(training_result_id);
    if(response) {
      return {
        coursePolicyUrl: response.course_policy_url
      } 
    }
    return {};
  }
);

export const acceptCoursePolicyEvents:any = createAsyncThunk(
  'acceptCoursepolicyEventsPlatform',
  async (params: AcceptCoursePolicyParams) => {
    const response = await acceptCoursePolicy(params);
    if(response) {
      return {
        isAccept: response.status
      }
    }
    return {};
  }
);

const coursePolicySlice = createSlice({
  name: 'coursePolicyEvents',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCoursePolicyEvents.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getCoursePolicyEvents.fulfilled, (state, action) => {
      state.isLoading = false;
      state.coursePolicyData.coursePolicyUrl = action.payload.coursePolicyUrl;
      state.error = '';
    });

    builder.addCase(getCoursePolicyEvents.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload as string;
    });

    builder.addCase(acceptCoursePolicyEvents.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(acceptCoursePolicyEvents.fulfilled, (state, action) => {
      state.isLoading = false;
      state.coursePolicyData.isAccept = action.payload.isAccept;
      state.error = '';
    });

    builder.addCase(acceptCoursePolicyEvents.rejected, (state, action) => {
      state.isLoading = false;
      state.coursePolicyData.isAccept = false;
      state.error = action.payload as string;
    });
  }
});

export const coursePolicyEventsDataSelector = (state: RootState) => state.coursePolicyEvents;
export default coursePolicySlice.reducer;
